import { useEffect, useState, useCallback } from "react";
import { useHistory, Link } from "react-router-dom";
import axios from "axios";
import { Trophy, FileEarmarkText } from "react-bootstrap-icons";
import notify from "../../common/ui/notify";
import PageHero from "../../common/ui/PageHero";
import { LoadingBlock, EmptyBlock } from "../../common/ui/StateBlock";
import { formatPrice, carTitle, formatDateTime } from "../../common/format";
import { INVOICE_TONE, invoiceStatusLabel, thumbStyle } from "./myShared";
import { t } from "./auctionI18n";
import "./Auction.css";
import "../../common/ui/ui.css";

const AuctionWon = () => {
    const history = useHistory();
    const [invoices, setInvoices] = useState(null);

    const load = useCallback(async () => {
        try {
            const res = await axios.get("/api/auction/my/activity");
            setInvoices(res.data.invoices || []);
        } catch (err) {
            if (err && err.response && err.response.status === 401) { history.replace("/auction/login"); return; }
            notify.apiError(err);
            setInvoices([]);
        }
    }, [history]);

    useEffect(() => { load(); }, [load]);

    if (invoices === null) return <div className="container auction-narrow"><LoadingBlock label={t("იტვირთება...", "Loading...", "Загрузка...", "Բեռնվում է...")} /></div>;

    const paid = invoices.filter((i) => i.status === "paid").length;
    const due = invoices.filter((i) => i.status !== "paid" && i.status !== "cancelled").length;

    return (
        <>
            <PageHero eyebrow="Carexpress" title={t("მოგებული ავტომობილები", "Won cars", "Выигранные авто", "Շահած մեքենաներ")} subtitle={t("თქვენ მიერ მოგებული ლოტები და მათი ინვოისები.", "The lots you have won and their invoices.", "Выигранные вами лоты и их счета.", "Ձեր շահած լոտերը և դրանց հաշիվները։")} />
            <div className="container auction-narrow auction-wide auction-my">
                <Link to="/auction/my" className="auction-back">← {t("ჩემი აუქციონები", "My auctions", "Мои аукционы", "Իմ աճուրդները")}</Link>

                {invoices.length === 0 ? (
                    <EmptyBlock title={t("ჯერ არ მოგიგიათ", "Nothing won yet", "Пока ничего не выиграно", "Դեռ ոչինչ չեք շահել")} message={t("როცა ლოტს მოიგებთ, აქ გამოჩნდება ინვოისთან ერთად.", "When you win a lot, it will show up here with its invoice.", "Когда вы выиграете лот, он появится здесь со счётом.", "Երբ լոտ շահեք, այն կհայտնվի այստեղ՝ հաշվի հետ։")}
                        action={<Link to="/auctions" className="cx-btn cx-btn-primary">{t("აუქციონები", "Auctions", "Аукционы", "Աճուրդներ")}</Link>} />
                ) : (
                    <>
                        <div className="auction-stat-row">
                            <div className="auction-stat"><strong>{invoices.length}</strong><span>{t("სულ მოგებული", "Total won", "Всего выиграно", "Ընդամենը շահած")}</span></div>
                            <div className="auction-stat"><strong>{due}</strong><span>{t("გადასახდელი", "Due", "К оплате", "Վճարման")}</span></div>
                            <div className="auction-stat"><strong>{paid}</strong><span>{t("გადახდილი", "Paid", "Оплачено", "Վճարված")}</span></div>
                        </div>

                        <section className="cx-card auction-my-section">
                            <h3><Trophy className="auction-sec-ico" /> {t("ჩემი მანქანები", "My cars", "Мои авто", "Իմ մեքենաները")}</h3>
                            <div className="auction-my-list">
                                {invoices.map((i) => (
                                    <div key={i.id} className="auction-my-row auction-won-row">
                                        <div className="auction-my-thumb" style={thumbStyle(i.images)} />
                                        <div className="auction-my-main">
                                            <strong>{carTitle(i)}</strong>
                                            <span className="auction-muted">{t("ინვოისი", "Invoice", "Счёт", "Հաշիվ")} #{i.id} · {t("ვადა", "Due", "Срок", "Ժամկետ")}: {formatDateTime(i.due_at)}</span>
                                        </div>
                                        <div className="auction-my-row-right">
                                            <span className="auction-won-price">{formatPrice(i.total, i.currency || "GEL")}</span>
                                            <span className={`auction-reserve ${INVOICE_TONE[i.status] || ""}`}>{invoiceStatusLabel(i.status)}</span>
                                            <Link to={`/auction/invoice/${i.id}`} className="cx-btn cx-btn-ghost auction-invoice-btn">
                                                <FileEarmarkText /> {t("ინვოისი", "Invoice", "Счёт", "Հաշիվ")}
                                            </Link>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <p className="auction-muted auction-my-pay-hint">{t("გადახდა ხდება ოპერატორთან; დადასტურების შემდეგ სტატუსი განახლდება.", "Payment is handled with the operator; the status updates once confirmed.", "Оплата производится у оператора; статус обновится после подтверждения.", "Վճարումը կատարվում է օպերատորի մոտ; կարգավիճակը կթարմացվի հաստատումից հետո։")}</p>
                        </section>
                    </>
                )}
            </div>
        </>
    );
};

export default AuctionWon;
